import { MultiSlideCarousel } from "components/carousel/multiSlide";

export default function Carousel({ slides }) {
  if (!slides.length) return null;

  const slidesMulti = slides.map((item, i) => {
    return {
      widths: [570, 570, 320],
      component: (
        <div
          key={i}
          className="pointer-events-none mx-auto h-100 min-h-[214px] w-[320px] space-y-[10px] object-cover object-center p-3 md:min-h-[381px] md:w-[570px]"
        >
          {item.tag ? (
            <div className="w-max-content bg-[rgba(2,2,49,0.05)] px-[6px] py-1">
              <p className="text-[14px] text-mono-30">{item.tag}</p>
            </div>
          ) : null}
          <p className="text-mono-40">{item.nameAndPosition}</p>
          <p className="font-italic">
            <i>{`"${item.testimonial}"`}</i>
          </p>
        </div>
      ),
    };
  });

  return (
    <div className="-mx-5 mb-[70px] max-h-fit lg:mx-0">
      <MultiSlideCarousel
        autoplay={true}
        belowSlides="prevNextWithCount"
        slides={slidesMulti}
        containerClasses="h-[350px] md:h-[182px]"
        slideClasses="h-100"
        paginationContainerClassesOverride="mt-[20px] md:mt-[30px] flex justify-center"
        responsiveGap={[100]}
        scaleCenter={false}
      />
    </div>
  );
}
